<div class="c-product row">
    <div class="col-9 p-0">
        <div class="titulo-producto">
            {{product.title}}
        </div>
    </div>
    <div class="col-3 p-0 align-self-end" (click)="toggle()" *ngIf="!bloquearCantidad">
        <img *ngIf="!isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-down.svg">
        <img *ngIf="isClicked" class="icn-arrow-down c-mover-derecha" src="assets/icons/icon-arrow-up.svg">
    </div>
    <div *ngIf="container" class="conteiner-blanco-wix"></div>
    <ng-container *ngIf="product.isOpen">
        <div class="col-12 c-product-detail">
            <div class="row mt-24">
                <div class="col-6 p-0">
                    <div class="c-texto__carro--producto">Tipo de venta</div>
                </div>
                <div class="col-6 p-0 c-texto__carro--valor2 "> {{product.tipoVenta | tipoVenta}} </div>
            </div>
            <div class="row mt-18">
                <div class="col-6 p-0">
                    <div class="c-texto__carro--producto">Producto</div>
                </div>
                <div class="col-6 p-0 c-texto__carro--valor2"> Webpay PLUS </div>
            </div>

            <div class="row">
                <div class="col p-0 align-self-start">
                </div>
                <div class="col p-0 align-self-end jus-right">
                    <i class="icon-eliminar c-mover-derecha tex-al-right" (click)="deleteProduct()"
                        *ngIf="!bloquearCantidad"></i>
                </div>
            </div>

            <!-- Implementacion de precio descuento para WIX-->
            <div *ngIf="descuentoActivo" class="c-discount-detail row">
                <div class="col-6 p-0 ">
                    <div class="c-texto__carro--producto label-text mt-15">Cód. Descuento:
                        <p class="discount-code-txt">{{codigoDescuento}}</p>
                    </div>
                </div>
                <div class="col-6 p-0 ">
                    <div class="c-texto__carro--producto discount-amount-txt mt-15">-${{ valorDescuento | thousandsPipe }}</div>
                </div>
            </div>
            <!-- FIN: Implementacion de precio descuento para WIX-->

        </div>
    </ng-container>
    <div class="col-6 p-0 p ">
        <div [ngClass]="{'mt-42':distanciaOk,'mt-48':!distanciaOk}" class="c-texto__carro--valor-a   ">Plan anual:
        </div>
    </div>
    <div class="col-6 p-0">
        <div *ngIf="!descuentoActivo" [ngClass]="{'mt-42':distanciaOk,'mt-48':!distanciaOk}" class="c-texto-valor-neto"><strong>${{ valorProducto | thousandsPipe }}</strong><br>valor aprox. con IVA</div>
        <div *ngIf="descuentoActivo" [ngClass]="{'mt-42':distanciaOk,'mt-48':!distanciaOk}" class="c-texto-valor-neto"><strong>${{ valorProductoPeso | thousandsPipe }}</strong><br>valor aprox. con IVA</div>
    </div>
    <div class="col-4 p-0"></div>
    <div class="col-8 p-0">
        <div class="c-texto-valor-peso">Equivalente a: {{(valorUf | number: '1.1-2' | changedot)}} UF + IVA</div>
    </div>

</div>